import $ from 'jquery';
const {
	paymentFieldsComponentAttribute
} = window.PayoneerData;

export const paymentMethodName = () => {
	return document.querySelector( '.woocommerce-checkout input[name="payment_method"]:checked' ).value ?? '';
}

export const selectedPaymentGateway = () => {
	return document.querySelector(
		'.woocommerce-checkout input[name="payment_method"]:checked'
	)
};

export const selectedPaymentGatewayId = () => {
	return selectedPaymentGateway()?.id;
};

export const getComponentNameFromPaymentBox = function ( paymentBox ) {
	return paymentBox
		?.querySelector( `[${ paymentFieldsComponentAttribute }]` )
		?.getAttribute( paymentFieldsComponentAttribute );
};
/**
 * TODO: Refactor this to be more scalable. Check overlap with getComponentNameByGatewayId()
 * @param gatewayId
 * @returns {*}
 */
export const isPayoneerGateway = ( gatewayId ) => {
	return /^payment_method_payoneer-(checkout|afterpay|klarna|affirm|bancontact|eps|ideal|multibanco|p24)/i.test( gatewayId );
};

export const isPayoneerGatewaySelected = () =>
	isPayoneerGateway( selectedPaymentGatewayId() );

export const isPayForOrder = () => {
	return window.PayoneerData.isPayForOrder === '1';
};

export const getPaymentBox = ( gatewayId ) => {
	const selector = '.payment_box.' + gatewayId;
	return document.querySelector( selector );
};

export const getSelectedPaymentBox = () =>
	getPaymentBox( selectedPaymentGatewayId() );

const hostedOverrideFlagInput = () => {
	const { hostedFlowOverrideFlag } = window.PayoneerData;
	return document.querySelector(
		`input[name="${ hostedFlowOverrideFlag }"]`
	);
};

export const submitOrderPayViaAjax = ( $form ) => {
	//Blocks the UI in the same way Woocommerce does (source: https://github.com/woocommerce/woocommerce/blob/6.0.1/plugins/woocommerce/assets/js/frontend/checkout.js#L454-L466)
	$form.block( {
		message: null,
		overlayCSS: {
			background: '#fff',
			opacity: 0.6,
		},
	} );

	return $.ajax( {
		type: 'POST',
		url: window.wc_checkout_params.ajax_url,
		xhrFields: {
			// This is important. We need the session cookie to access the LIST in the back-end
			withCredentials: true,
		},
		dataType: 'json',
		data: {
			action: 'payoneer_order_pay',
			fields: $form.serialize(),
			params: new URL( document.location ).searchParams.toString(),
		},
	} ).always( () => $form.unblock() );
};

export const isBlockCheckout = () =>
	window?.PayoneerData?.isBlockCheckout === '1';

export const focusOnSelectedGateway = () => {
	selectedPaymentGateway()?.focus();
}
